var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.001C24.8366 32.001 32 24.8375 32 16.001C32 7.16442 24.8366 0.000976562 16 0.000976562C7.16344 0.000976562 0 7.16442 0 16.001C0 24.8375 7.16344 32.001 16 32.001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 0.000976562C10.3269 0.000976562 5.34381 2.95366 2.50281 7.40591L24.2002 29.7415C28.8717 26.9477 32.0001 21.8399 32.0001 16.001C32.0001 7.16448 24.8366 0.000976562 16.0001 0.000976562Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16.0009C32 11.8496 30.4189 8.06781 27.826 5.22418V26.7777C30.4189 23.9341 32 20.1523 32 16.0009Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9868 30.1181L21.6628 30.117L22.1798 28.5227L22.6986 30.1164L23.5392 30.1159C24.0547 29.84 24.5533 29.5367 25.033 29.2078L2.79306 6.96796C2.42656 7.50271 2.09231 8.06108 1.79175 8.63983L1.98937 9.24683L3.66531 9.24577L2.31006 10.2317L2.82894 11.8254L1.47244 10.8411L0.663375 11.4296C0.232063 12.8781 0 14.4125 0 16.001C0 24.8375 7.1635 32.001 16 32.001C17.8683 32.001 19.6614 31.6803 21.3281 31.0915L19.9868 30.1181ZM3.56869 15.3054L4.08556 13.7111L2.72919 12.7268L4.40513 12.7257L4.92206 11.1314L5.44094 12.7251L7.11688 12.724L5.76156 13.71L6.28044 15.3036L4.92394 14.3194L3.56869 15.3054ZM7.02025 18.7836L7.53713 17.1894L6.18075 16.205L7.85669 16.204L8.37362 14.6096L8.8925 16.2033L10.5684 16.2023L9.21319 17.1882L9.73206 18.7819L8.37556 17.7976L7.02025 18.7836ZM10.4718 22.2619L10.9886 20.6676L9.63225 19.6833L11.3082 19.6822L11.8251 18.0879L12.344 19.6816L14.0199 19.6805L12.6647 20.6665L13.1836 22.2601L11.8271 21.2758L10.4718 22.2619ZM15.2786 24.7542L13.9233 25.7401L14.4401 24.1459L13.0837 23.1615L14.7597 23.1605L15.2767 21.5661L15.7956 23.1598L17.4715 23.1588L16.1162 24.1447L16.6351 25.7384L15.2786 24.7542ZM17.3748 29.2184L17.8917 27.6241L16.5353 26.6398L18.2113 26.6387L18.7282 25.0444L19.2471 26.6381L20.923 26.637L19.5678 27.623L20.0866 29.2166L18.7301 28.2323L17.3748 29.2184Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBa);
export default __webpack_public_path__ + "static/media/BA.c9a7977f.svg";
export { ForwardRef as ReactComponent };